import React from 'react';
import './shared.css';

const Membership: React.FC = () => {
  return (
    <div className="page-container">
      <div className="content-card">
        <h1>Membership</h1>

        <p style={{ textAlign: 'center' }}>
          <strong>Here are the MOST Current Membership Prices</strong>
        </p>

        <p style={{ color: '#ff0000' }}>
          <em><strong>Additionally for our Monthly NEW Members, we offer these benefits:</strong></em>
        </p>

        <ol>
          <li>
            <em>
              Referral by a NEW Monthly Member by bringing another NEW Member into the Collective,
              will redeem the Monthly Member an additional 30 Days to his Membership FREE.
            </em>
          </li>
          <li>
            <em>
              Participation to the Forum based on a REPLY and HELP to a Member 5 times within the Month,
              will add to his points rating from NEWBIE to a Veteran, thus additionally add to his FREE Month.
              (This is based on participation level within a month’s time)
            </em>
          </li>
          <li>
            <em>
              If NEW Member reaches 120 REPLIES and HELP within a 12 Month period, he will receive the status
              of Veteran, and will receive FREE Months when at a level of a PLATINUM Member of the “Collective”
              (Based and Monitored by ADMIN)
            </em>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default Membership;

